/*
  Lullmap storefront behavior: custom analytics events and the mobile sticky buy bar.
  Events go through Shopify.analytics.publish so any installed web pixel (GA4, Meta, custom) can subscribe.
*/
(function () {
  function track(name, data) {
    try {
      if (window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === 'function') {
        var result = Shopify.analytics.publish(name, data || {});
        if (result && typeof result.catch === 'function') result.catch(function () {});
      }
    } catch (e) {}
  }
  window.lullmapTrack = track;

  // buy_click: publish, then give the pixel a moment before following the checkout permalink.
  document.addEventListener('click', function (event) {
    var link = event.target.closest('[data-buy]');
    if (!link) return;
    track('buy_click', { placement: link.getAttribute('data-placement') || 'section' });
    if (event.metaKey || event.ctrlKey || event.shiftKey || event.button !== 0) return;
    event.preventDefault();
    setTimeout(function () { window.location.href = link.href; }, 150);
  });

  // Sticky bar appears once the hero (or the first buy button) scrolls out of view.
  var bar = document.querySelector('[data-sticky-buy]');
  var anchor = document.querySelector('[data-hero]') || document.querySelector('[data-buy]:not([data-placement="sticky"])');
  if (bar && anchor && 'IntersectionObserver' in window) {
    bar.hidden = false;
    var finalBuy = document.querySelector('[data-final-buy]');
    var heroVisible = true;
    var finalVisible = false;
    var update = function () {
      var show = !heroVisible && !finalVisible;
      bar.classList.toggle('is-visible', show);
      bar.setAttribute('aria-hidden', show ? 'false' : 'true');
      bar.inert = !show;
    };
    new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.target === anchor) heroVisible = entry.isIntersecting;
        else finalVisible = entry.isIntersecting;
      });
      update();
    }).observe(anchor);
    if (finalBuy) {
      new IntersectionObserver(function (entries) {
        finalVisible = entries[0].isIntersecting;
        update();
      }).observe(finalBuy);
    }
    update();
  }
})();
